import React from "react";
// Components

import { useParams } from "react-router-dom";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useDispatch } from "react-redux";
import { dataPortalResetFiltersAction, speciesResetFiltersAction } from "store/filters/reducer.actions";
import { filtersInitialState } from "store/filters/initialState";
import { SelectedPublisher, SelectedTypes, Date } from "./Components";

const AppliedFilters = () => {
  // Getting speciesFilter state from Redux store
  const { dataPortalFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const dispatch = useDispatch();
  const { organizationId, programId, communityId } = useParams<{
    organizationId: string;
    programId: string;
    communityId: string;
  }>();

  const clearAllFilters = () => {
    dispatch(dataPortalResetFiltersAction());
  };
  return (
    <div className="flex flex-wrap items-start justify-start flex-grow-0 flex-shrink-0 gap-1">
      {isAnyDataPortalFilterApplied(dataPortalFilter) && (
        <button
          onClick={clearAllFilters}
          type="button"
          className="flex items-center justify-center flex-grow-0 gap-1 border-none outline-none focus:outline-none rounded-3xl"
        >
          <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative pt-1.5 pb-2">
            <p className="flex-grow-0 flex-shrink-0 text-sm font-semibold text-center text-primary">
              Clear All Filters
            </p>
          </div>
        </button>
      )}
      <div
        style={{ maxWidth: "90%" }}
        className="flex flex-wrap items-center justify-start"
      >
        <div className="flex flex-wrap gap-2">
          <SelectedTypes />
          <Date
            name="creationDate"
            from={dataPortalFilter.creationDate.from}
            to={dataPortalFilter.creationDate.to}
            isApplied={dataPortalFilter.creationDate?.applied}
          />
          <SelectedPublisher />
        </div>
      </div>
    </div>
  );
};

export default AppliedFilters;

// Function to check if any filter is applied
export function isAnyDataPortalFilterApplied(dataPortalFilter: any): boolean {
  const { creationDate, fileType, publishers, communityIds } = dataPortalFilter;
  const applied =
    creationDate?.applied || fileType?.applied || publishers?.applied;

  return applied;
}
